import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate('/');
  };

  const tryAgain = () => {
    // Navigate to billing tab on dashboard
    navigate('/?tab=billing');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-stone-50 to-stone-100 p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="py-12 text-center">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-amber-600" />
          </div>
          <h2 className="text-xl font-semibold text-stone-800 dark:text-stone-200 mb-2">
            Payment Cancelled
          </h2>
          <p className="text-stone-600 dark:text-stone-400 mb-8">
            No worries! Your payment was cancelled and you haven't been charged.
            You can try again anytime from your billing settings.
          </p>
          <div className="space-y-3">
            <Button
              onClick={tryAgain}
              variant="memberGold"
              className="w-full"
            >
              <CreditCard className="h-4 w-4 mr-2" />
              Try Again
            </Button>
            <Button
              onClick={goToDashboard}
              variant="outline"
              className="w-full"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Return to Dashboard
            </Button>
          </div>
          <p className="text-sm text-stone-500 dark:text-stone-400 mt-6">
            Questions? Contact us at{' '}
            <a href="mailto:info@owazamartialarts.com" className="text-amber-600 hover:underline">
              info@owazamartialarts.com
            </a>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelled;
